import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptActivitiesModule } from "@org-common/lib/activities/activities.module";
import { PersonalDashboardPageComponent } from "./personal-dashboard-page/personal-dashboard-page.component";
import { personalDashboardPageRoute } from "./personal-dashboard-page/personal-dashboard-page.route";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AdaptButtonModule,
        AdaptToolbarModule,
        AdaptActivitiesModule,
        AdaptTooltipModule,
    ],
    declarations: [
        PersonalDashboardPageComponent,
    ],
})

export class AdaptPersonalDashboardModule {
    public static readonly Routes = [
        ...personalDashboardPageRoute.routes,
    ];
}
